import { memo, type CSSProperties } from 'react';
import { Mic } from 'lucide-react';
import type { CwInboxStage, InboxConversation } from '@/api/inboxTypes';
import { formatRowTime, previewOf, whoLine } from '@/lib/messageModel';
import { Avatar } from './Avatar';

interface Props {
  conv: InboxConversation;
  stage: CwInboxStage | null;
  myUserId: number | null;
  /** Название канала для подписи, когда в списке перемешаны каналы. */
  inboxName?: string;
  onOpen: (c: InboxConversation) => void;
}

export const ConversationRow = memo(function ConversationRow({ conv, stage, myUserId, inboxName, onOpen }: Props) {
  const pv = previewOf(conv, myUserId);
  const who = whoLine(conv, myUserId);
  const unread = conv.unreadCount;
  const t = formatRowTime(conv.lastActivityAt);
  return (
    <button
      type="button"
      className="row"
      onClick={() => onOpen(conv)}
    >
      <Avatar name={conv.contact.name} seed={conv.contact.id || conv.id} channelType={conv.channelType} />
      <span className="rb">
        <span className="l1">
          <span className="nm">
            {stage && <span className="sdot" style={{ background: stage.color || 'var(--accent)' } as CSSProperties} title={stage.name} />}
            {conv.contact.name}
          </span>
          <span className={`tm ${unread ? 'hot' : ''}`}>{t}</span>
        </span>
        <span className="l2">
          <span className="lm">
            {pv.voice && <Mic aria-hidden />}
            {pv.prefix && <span className="me">{pv.prefix}</span>}
            {pv.text}
          </span>
          {unread > 0 && <span className="badge tnum">{unread > 99 ? '99+' : unread}</span>}
        </span>
        {(who || inboxName) && (
          <span className="l2">
            {who && <span className={`who ${who.bot ? 'bot' : ''}`}>{who.text}</span>}
            {inboxName && <span className="who">{inboxName}</span>}
          </span>
        )}
      </span>
    </button>
  );
});
